var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavBar',{staticClass:"ImportNavBar"},[(_vm.superuser)?_c('router-link',{staticClass:"d-inline-flex align-center mr-3",attrs:{"to":{ name: 'Dashboard', params: { municipality: _vm.activeMunicipalitySlug } }}},[_c('SvgIcon',{attrs:{"icon":"cog-regular","has-fill":true}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }